import { DashboardPeriodeFilterOptions, DeliveryStatus, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading } from "utils/Constant";
import { useModal } from "../../components/modal/ModalContext";
import { PagesTitle } from "components/Cards";
import { useEffect, useState } from "react";
import { CheckResponse, money } from "utils/helpers";
import moment from "moment";
import SmallButton from "components/Button/SmallButton";
import { useCallApi } from "api/apiHooks";

export default function Dashboard(){
	const { openModal, closeModal } = useModal()
	const { fetchDashboardHeader, fetchRentalOrderList, fetchDeliverRental } = useCallApi()

	const [periodeFilter, setPeriodeFilter] = useState('1')
	const [dashboardHeader, setDashboardHeader] = useState([])
	const [rentalOrderList, setRentalOrderList] = useState([])
	const [activeRentalOrderList, setActiveRentalOrderList] = useState([])

	const deliverRentalBtnClick = (id) => {
		openModal(ModalTypeConfirmation, {
			onConfirm: () => {
				openModal(ModalTypeLoading)

				fetchDeliverRental(id).then((res) => {
					if (CheckResponse(res)) {
						fetchRentalOrderList('', '0', '', '1', 1000, 0, '1').then((res) => {
							if (CheckResponse(res)) {
								setRentalOrderList(res)
								
								// Get Ongoing Rental List
								fetchRentalOrderList('', '0', '', '1', 1000, 0, '2').then((res) => {
									if (CheckResponse(res)) {
										setActiveRentalOrderList(res)

										closeModal()
									} else {
										openModal(ModalTypeFail, { message: res.message })
									}
								})
							} else {
								openModal(ModalTypeFail, { message: res.message })
							}
						})
					} else {
						openModal(ModalTypeFail, { message: res.message })
					}
				})
			},
		})

		
	}

	useEffect(() => {
		openModal(ModalTypeLoading)

		fetchDashboardHeader(periodeFilter).then((res) => {
			if (CheckResponse(res)) {
				setDashboardHeader(res.data)

				fetchRentalOrderList('', '0', '', '1', 1000, 0, '1').then((res) => {
					if (CheckResponse(res)) {
						setRentalOrderList(res)

						// Get Ongoing Rental List
						fetchRentalOrderList('', '0', '', '1', 1000, 0, '2').then((res) => {
							if (CheckResponse(res)) {
								setActiveRentalOrderList(res)

								closeModal()
							} else {
								openModal(ModalTypeFail, { message: res.message })
							}
						})
					} else {
						openModal(ModalTypeFail, { message: res.message })
					}
				})
			} else {
				openModal(ModalTypeFail, { message: res.message })
			}
		})
	}, [periodeFilter])

	return (
		<div className="p-3 sm:p-6">
			<PagesTitle title='Dashboard' />

			<div className="mt-3">
				<div className="flex justify-end">
					<div className="flex gap-3 bg-white px-1 py-1 border rounded-full">
						{DashboardPeriodeFilterOptions.map((data, i) => {
							return (
								<button 
									className={`${periodeFilter === data.value ? 'bg-black text-white rounded-full' : ''}
										px-3 py-1 text-xs
									`}
									onClick={() => { setPeriodeFilter(data.value) }}
									key={i}
								>
									{data.label}
								</button>
							)
						})}
					</div>
				</div>
				
				<div className="flex gap-3 mt-3">

					<div className="flex flex-1 bg-white rounded-xl p-6 border">
						<div className="flex flex-1 flex-col">
							<span>Total</span>
							
							<div className="flex flex-1 w-full justify-between tracking-wider">
								<span className="text-3xl">Rp { money(String(dashboardHeader?.reduce((sum, item) => sum + Number(item.amount || 0), 0))) ?? 0 }</span>
								<span className="text-3xl">{ dashboardHeader?.reduce((sum, item) => sum + Number(item.totalTransaction || 0), 0) ?? 0 }</span>
							</div>
						</div>
					</div>

					<div className="flex bg-white rounded-xl p-6 border w-4/12">
						<div className="flex flex-1 flex-col">
							<span>Total Penjualan</span>
							
							<div className="flex flex-1 w-full justify-between tracking-wider">
								<span className="text-2xl">Rp { money(dashboardHeader?.find(x => x.type === 'sales')?.amount ?? 0) }</span>
								<span className="text-2xl">{ dashboardHeader?.find(x => x.type === 'sales')?.totalTransaction ?? 0 }</span>
							</div>
						</div>
					</div>

					<div className="flex bg-white rounded-xl p-6 border w-3/12">
						<div className="flex flex-1 flex-col">
							<span>Total Rental</span>
							
							<div className="flex flex-1 w-full justify-between tracking-wider">
								<span className="text-2xl">Rp { money(dashboardHeader?.find(x => x.type === 'rental')?.amount ?? 0) }</span>
								<span className="text-2xl">{ dashboardHeader?.find(x => x.type === 'rental')?.totalTransaction ?? 0 }</span>
							</div>
						</div>
					</div>

				</div>
				
			</div>

			<div className="mt-4 bg-white rounded-xl p-6 border">
				<span className="text-base font-semibold">Up Comming Delivery</span>
				
				<div className="mt-3 flex flex-col gap-2 max-h-82 overflow-y-auto text-sm font-light">
					{ rentalOrderList?.data?.listData?.map((data, i) => {
						return(
							<div className="flex flex-col gap-2 border rounded-lg p-3 w-full">
								<div className="flex justify-between">
									<div className="flex flex-col">
										<span className="font-semibold">{ data.customerName }</span>
										<span>{ data.brandName } { data.productName }</span>
										<span>Fee: Rp { money(data.deliveryFee) }</span>
									</div>
									<div className="flex flex-col text-right">
										<span>{ data.deliveryLocation }</span>
										<span>{ moment(data.rentalDate).format("DD MMM YYYY - HH:mm") }</span>
										<span>
											{ data.deliveryStatus !== null ? 
												DeliveryStatus.find(x => x.value === String(data.deliveryStatus)).label :
												'-' 
											}
										</span>
									</div>
								</div>

								<div className="flex flex-1">
									<SmallButton 
										buttonName={'Item Delivered'}
										visible={true}
										onClick={() => { deliverRentalBtnClick(data.rentalOrderId) }}
									/>
								</div>
							</div>
							
						)
					})}
				</div>
			</div>

			<div className="mt-4 bg-white rounded-xl p-6 border">
				<span className="text-base font-semibold">Ongoing Rental</span>

				<div className="mt-3 flex flex-col gap-2 max-h-82 overflow-y-auto text-sm font-light">
					{ activeRentalOrderList?.data?.listData?.map((data, i) => {
						return(
							<div className="flex flex-col gap-2 border rounded-lg p-3 w-full">
								<div className="flex justify-between">
									<div className="flex flex-col">
										<span className="font-semibold">{ data.customerName }</span>
										<span>{ data.brandName } { data.productName }</span>
										<span>Fee: Rp { money(data.deliveryFee) }</span>
									</div>
									<div className="flex flex-col text-right">
										<span>{ data.deliveryLocation }</span>
										<span>{ moment(data.rentalDate).format("DD MMM YYYY - HH:mm") }</span>
										<span>
											{ data.deliveryStatus !== null ? 
												DeliveryStatus.find(x => x.value === String(data.deliveryStatus)).label :
												'-' 
											}
										</span>
									</div>
								</div>
							</div>
							
						)
					})}
				</div>
			</div>
		</div>
	)

}